import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorService } from '../../../shared/services/behavior/behavior.service';
import { Credit } from '../../models/credit';

@Component({
  selector: 'app-choix-pack',
  templateUrl: './choix-pack.component.html',
  styleUrls: ['./choix-pack.component.scss'],
})
export class ChoixPackComponent implements OnInit {
  @Input() packs: Credit.Pack[] = [];
  @Input() commande!: Credit.Commande;
  @Input() isCB = false;
  @Input() isAutoliquidation = false;

  @Output() packSelected = new EventEmitter<Credit.Pack>();
  @Output() renouvellementAutoSet = new EventEmitter<boolean>();
  @Output() commander = new EventEmitter<void>();
  @Output() payer = new EventEmitter<void>();

  get isSpecialPackSelected(): boolean {
    return !!this.commande?.pack?.isSpecialPack;
  }

  get activerRenouvellementAutoTitle(): string {
    return this.isSpecialPackSelected
      ? "Le renouvellement automatique est désactivé pour l'offre découverte"
      : 'Activer le renouvellement automatique';
  }

  get isSpecialPack(): boolean {
    return this.packs.some((pack) => pack.isSpecialPack);
  }

  get spacialPackDescription(): string {
    return this.packs.find((pack) => pack.isSpecialPack)
      ?.specialDescription as string;
  }

  get renouvellementAuto(): boolean {
    return this.commande?.isRenouvellementAuto as boolean;
  }

  get canCommander(): boolean {
    return (
      !!this.commande?.pack &&
      (this.isCB || this.commande?.isRenouvellementAuto !== undefined)
    );
  }

  get commanderButtonTitle(): string {
    if (!this.canCommander) {
      return 'Veuillez sélectionner un pack pour continuer';
    }
    return this.isCB ? 'payer' : 'commander';
  }

  constructor(
    private readonly behaviorService: BehaviorService,
    private readonly titleService: Title,
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Commander | Perval.fr');
    this.behaviorService.scrollToTheTop();
  }

  onPackSelected(pack: Credit.Pack): void {
    this.packSelected.emit(pack);
  }

  setRenouvellementAutoValue(isRenouvellementAuto: boolean): void {
    this.renouvellementAutoSet.emit(isRenouvellementAuto);
  }

  onCommander(): void {
    this.commander.emit();
  }

  onPayer(): void {
    this.payer.emit();
  }
}
